import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  changeDateFormat,
} from "../../../../../../helpers";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changeSettingValue,
  getMasterSetting,
  refreshPmMasterSetting,
  savePmMasterSetting,
  updatePmMasterSetting,
  updatePmMasterSettingStatus,
} from "../../../../../../Redux/actions";
import ModelContainer from "../../../../../Components/ModelContainer";
import ErrorContainer from "../../../../../Components/ErrorContainer";

const pmMasterSettingSchema = yup.object({
  id: yup.string().nullable(),
  payment_method_id: yup.string().required(),
  accounts: yup.array().nullable(),
});
const editPmMasterSettingSchema = yup.object({
  master_id: yup.string().required(),
  payment_method_id: yup.string().required(),
  merchant_id: yup.string().required(),
  cluster_id: yup.string().required(),
  store_merchant_id: yup.string().required(),
});

const PaymentMethod = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    master_setting_details,
    pmMasterSettingModal,
    is_pmMasterSetting_loading,
    editPmMasterSettingModal,
    is_editPmMasterSetting_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(getMasterSetting());

    return () => {
      dispatch(changeSettingValue("master_setting_details", null));
    };
  }, []);

  /* PmMasterSettings */
  const initialpmMasterSettingForm = {
    id: "",
    payment_method_id: "",
    accounts: [],
  };
  const {
    register: pmMasterSettingReg,
    formState: { errors: pmMasterSettingErrors },
    handleSubmit: pmMasterSettingSubmit,
    setValue: pmMasterSettingSetValue,
    reset: pmMasterSettingReset,
  } = useForm({
    resolver: yupResolver(pmMasterSettingSchema),
    defaultValues: initialpmMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [pmMasterSettingInputForm, setPmMasterSettingInputForm] = useState(
    initialpmMasterSettingForm
  );

  const [accounts, setAccounts] = useState([]);

  const changePmMasterSettingInputHandler = (input, val) => {
    pmMasterSettingSetValue(input, val);
    setPmMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialPmMasterSettingModalState = (
    initailVal = initialpmMasterSettingForm
  ) => {
    setPmMasterSettingInputForm(initailVal);
    pmMasterSettingReset(initailVal);
  };
  const closePmMasterSettingModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("pmMasterSettingModal", value));
      initialPmMasterSettingModalState();
    },
    [pmMasterSettingModal]
  );
  const submitPmMasterSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 1;
    console.log("submitPmMasterSettingForm", data);
    dispatch(savePmMasterSetting(data));
  };
  const submitPmMasterUpdateSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 2;
    console.log("submitPmMasterUpdateSettingForm", data);
    dispatch(savePmMasterSetting(data));
  };
  const deletePmMasterSettingHandler = (id) => {
    // dispatch(deletePmMasterSetting({ id }));
  };

  /* Edit pm Master Setting */

  const initialeditPmMasterSettingForm = {
    master_id: "",
    payment_method_id: "",
    merchant_id: "",
    cluster_id: "",
    store_merchant_id: "",
  };
  const {
    register: editPmMasterSettingReg,
    formState: { errors: editPmMasterSettingErrors },
    handleSubmit: editPmMasterSettingSubmit,
    setValue: editPmMasterSettingSetValue,
    reset: editPmMasterSettingReset,
  } = useForm({
    resolver: yupResolver(editPmMasterSettingSchema),
    defaultValues: initialeditPmMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [selectedPmSetting, setSelectedPmSetting] = useState(null);
  const [editPmMasterSettingInputForm, setEditPmMasterSettingInputForm] =
    useState(initialeditPmMasterSettingForm);

  const changeEditPmMasterSettingInputHandler = (input, val) => {
    editPmMasterSettingSetValue(input, val);
    setEditPmMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialEditPmMasterSettingModalState = (
    initailVal = initialeditPmMasterSettingForm
  ) => {
    setEditPmMasterSettingInputForm(initailVal);
    editPmMasterSettingReset(initailVal);
  };
  const closeEditPmMasterSettingModal = useCallback(
    (value) => {
      if (!value) setSelectedPmSetting(null);
      dispatch(changeSettingValue("editPmMasterSettingModal", value));
      initialEditPmMasterSettingModalState();
    },
    [editPmMasterSettingModal]
  );
  const submitEditPmMasterSettingForm = (data) => {
    data.setting_type = 1;
    console.log("submitEditPmMasterSettingForm", data);
    dispatch(updatePmMasterSetting(data));
  };
  const submitEditPmMasterUpdateSettingForm = (data) => {
    data.setting_type = 2;
    console.log("submitEditPmMasterUpdateSettingForm", data);
    dispatch(updatePmMasterSetting(data));
  };
  const deleteEditPmMasterSettingHandler = (id) => {
    // dispatch(deleteEditPmMasterSetting({ id }));
  };

  const editPmMasterSettingHandler = (editPmMasterSetting) => {
    setSelectedPmSetting(editPmMasterSetting);
    closeEditPmMasterSettingModal(true);
    const editValues = {
      master_id: editPmMasterSetting?.id ?? "",
      payment_method_id: editPmMasterSetting?.payment_method_id ?? "",
      merchant_id: editPmMasterSetting?.merchant_id ?? "",
      cluster_id: editPmMasterSetting?.cluster_id ?? "no",
      store_merchant_id: editPmMasterSetting?.store_merchant_id ?? "",
    };
    initialEditPmMasterSettingModalState(editValues);
  };

  /* Edit pm Master Setting END */

  const updatePmSettingStatusHandler = (id, status) => {
    dispatch(updatePmMasterSettingStatus({ id, status }));
  };
  const refreshPmMasterSettingHandler = (id) => {
    dispatch(refreshPmMasterSetting({ id }));
  };

  const getPmMasterSettingAction = (pmMasterSetting) => {
    let res = null;
    if (pmMasterSetting?.status == 1) {
      res = (
        <>
          {pmMasterSetting?.setting_type == 1 ? (
            <a
              role="button"
              class="circle_icon edit_tooltip editAccountPm"
              onClick={() => editPmMasterSettingHandler(pmMasterSetting)}
            >
              <i class="iconSprites edit-icon"></i>
            </a>
          ) : (
            <a
              role="button"
              class="circle_icon refresh_tooltip refresh_setting_pm"
              onClick={() => refreshPmMasterSettingHandler(pmMasterSetting?.id)}
            >
              <i class="iconSprites refresh-icon"></i>
            </a>
          )}

          <a
            role="button"
            class="circle_icon pwr_tooltip on"
            onClick={() =>
              updatePmSettingStatusHandler(pmMasterSetting?.id, "inactive")
            }
          >
            <i class="iconSprites pwr-icon"></i>
          </a>
        </>
      );
    } else {
      res = (
        <a
          role="button"
          class="circle_icon pwr_tooltip"
          onClick={() =>
            updatePmSettingStatusHandler(pmMasterSetting?.id, "active")
          }
        >
          <i class="iconSprites pwr-icon"></i>
        </a>
      );
    }
    return res;
  };

  const checkAccountIsClicked = (account) => {
    let res = true;

    if (
      checkArray(accounts) &&
      checkArray(account?.cluster) &&
      checkArray(account?.cluster.filter((p) => checkArray(p.stores)))
    ) {
      let accountIds = [];
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              accountIds.push(store.merchant_id);
            });
          }
        });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return accountIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const checkClusterIsClicked = (cluster) => {
    let res = true;
    if (checkArray(accounts) && checkArray(cluster?.stores)) {
      let clusterIds = [];
      cluster?.stores.map((store) => {
        clusterIds.push(store.merchant_id);
      });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return clusterIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const otherAccountClickHandler = (other_account) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == other_account?.id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != other_account?.id
      );
    } else {
      newAccounts.push({
        merchant_id: other_account?.parent_merchant_id,
        cluster_id: other_account?.id,
        store_merchant_id: other_account?.id,
      });
    }
    setAccounts(newAccounts);
  };
  const accountClickHandler = (account) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.merchant_id != account?.id);
    const checkIsClicked = checkAccountIsClicked(account);
    if (checkArray(account?.cluster) && !checkIsClicked) {
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              newAccounts.push({
                merchant_id: account?.id,
                cluster_id: store?.cluster_id,
                store_merchant_id: store?.merchant_id,
              });
            });
          }
        });
    }
    setAccounts(newAccounts);
  };

  const clusterClickHandler = (merchantId, cluster) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.cluster_id != cluster?.id);
    const checkIsClicked = checkClusterIsClicked(cluster);
    if (checkArray(cluster?.stores) && !checkIsClicked) {
      cluster?.stores.map((store) => {
        newAccounts.push({
          merchant_id: merchantId,
          cluster_id: store?.cluster_id,
          store_merchant_id: store?.merchant_id,
        });
      });
    }
    setAccounts(newAccounts);
  };

  const storeClickHandler = (merchantId, store) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == store?.merchant_id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != store?.merchant_id
      );
    } else {
      newAccounts.push({
        merchant_id: merchantId,
        cluster_id: store?.cluster_id,
        store_merchant_id: store?.merchant_id,
      });
    }
    setAccounts(newAccounts);
  };

  const msetingArr = {
    1: "Master & Lock",
    2: "Push & Forgot",
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="paymentMethodMasterSettings">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseOne"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseOne"
        >
          <div className="col d-flex align-items-center">
            <h4 className="event-alert p-0 mb-0">
              Payment Method Master Settings
            </h4>
          </div>{" "}
        </button>
      </h2>
      <div
        id="panelsStayOpen-collapseOne"
        className="accordion-collapse collapse show"
        aria-labelledby="paymentMethodMasterSettings"
      >
        <div className="">
          <div className="row mx-0">
            <div className="container px-0">
              <div className="shadowclass mt-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th className="col-2">Payment Method</th>
                        <th className="col-2">Cluster Name</th>
                        <th>Account Name</th>
                        <th>Master Setting</th>
                        <th>Last Push Date</th>
                        <th>Status</th>
                        <th className="action-td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(
                        master_setting_details?.payment_methods?.master_settings
                      ) &&
                        master_setting_details?.payment_methods?.master_settings.map(
                          (setting) => {
                            return (
                              <tr>
                                <td>
                                  {setting?.payment_method?.method_name ?? ""}
                                </td>
                                <td>
                                  {setting?.cluster?.cluster_name
                                    ? setting?.cluster?.cluster_name
                                    : "Orphan - No Cluster"}
                                </td>
                                <td>{setting?.store_merchant?.account_name}</td>
                                <td>{msetingArr?.[setting?.setting_type]}</td>
                                <td>
                                  {changeDateFormat(
                                    setting?.push_date,
                                    "MMMM DD, yyyy"
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {setting?.status == 1 ? (
                                    <span class="green_tag"> Active </span>
                                  ) : (
                                    <span class="bordered_tag"> Inactive </span>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                  {getPmMasterSettingAction(setting)}{" "}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                  <div className="my-3">
                    <button
                      className="btn green-btn-revert add-plus"
                      id="addCount"
                      type="button"
                      onClick={() => closePmMasterSettingModal(true)}
                    >
                      <i className="i-icon"> </i> Add Account Payment Method
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`${
          pmMasterSettingInputForm?.id != "" ? "EDIT" : "ADD"
        }  ACCOUNT PAYMENT METHOD`}
        open={pmMasterSettingModal}
        closeModal={closePmMasterSettingModal}
        submitModal={pmMasterSettingSubmit(submitPmMasterSettingForm)}
        updateModal={pmMasterSettingSubmit(submitPmMasterUpdateSettingForm)}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_pmMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="SalesTypeGeneralSettingSalesForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="SalesTypeTypeName" class="required">
                  Select Payment Method
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][payment_method_id]"
                    class="required valid"
                    id="MasterSettingsPaymentMethodId"
                    {...pmMasterSettingReg("payment_method_id")}
                    value={pmMasterSettingInputForm?.payment_method_id}
                    onChange={(e) =>
                      changePmMasterSettingInputHandler(
                        "payment_method_id",
                        e?.target?.value ?? ""
                      )
                    }
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.payment_methods?.paymentMethods
                    ) &&
                      master_setting_details?.payment_methods?.paymentMethods.map(
                        (method) => {
                          return (
                            <option value={method?.id}>
                              {method.method_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={pmMasterSettingErrors}
                    name="payment_method_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.payment_methods?.all_accounts
                    ) &&
                      master_setting_details?.payment_methods?.all_accounts.map(
                        (groups) => {
                          return (
                            <Fragment key={groups?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`group_id_${groups?.id}`}
                                onClick={() => accountClickHandler(groups)}
                                checked={checkAccountIsClicked(groups)}
                              />
                              <label for={`group_id_${groups?.id}`}>
                                Group - {groups?.account_name ?? ""}
                              </label>

                              <a
                                class="link"
                                role="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`.account-multi-collapse-${groups?.id}`}
                                aria-expanded="false"
                                aria-controls={`account-collapse-${groups?.id}`}
                              >
                                {" "}
                                <i className="btn dropdown" />{" "}
                              </a>
                              <div
                                id={`account-collapse-${groups?.id}`}
                                className={`group-collapse inner-checkbox collapse account-multi-collapse-${groups?.id}`}
                              >
                                {checkArray(groups?.cluster) &&
                                  groups?.cluster
                                    .filter((p) => checkArray(p.stores))
                                    .map((cluster) => {
                                      return (
                                        <div class="groupSec">
                                          <div className="checkbox avaiCheck flex-wrap">
                                            <input
                                              type="checkbox"
                                              className="avail_checkbox"
                                              value={true}
                                              id={`cluster_id_${cluster?.id}`}
                                              onClick={() =>
                                                clusterClickHandler(
                                                  groups?.id,
                                                  cluster
                                                )
                                              }
                                              checked={checkClusterIsClicked(
                                                cluster
                                              )}
                                            />
                                            <label
                                              for={`cluster_id_${cluster?.id}`}
                                            >
                                              Cluster -{" "}
                                              {cluster?.cluster_name ?? ""}
                                            </label>
                                            {checkArray(cluster?.stores) && (
                                              <>
                                                <a
                                                  class="link"
                                                  role="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`.cluster-multi-collapse-${cluster?.id}`}
                                                  aria-expanded="false"
                                                  aria-controls={`cluster-collapse-${cluster?.id}`}
                                                >
                                                  {" "}
                                                  <i className="btn dropdown" />{" "}
                                                </a>
                                                <div
                                                  class={`pt-3 collapse inner-checkbox cluster-multi-collapse-${cluster?.id}`}
                                                  id={`cluster-collapse-${cluster?.id}`}
                                                >
                                                  {checkArray(
                                                    cluster?.stores
                                                  ) &&
                                                    cluster?.stores.map(
                                                      (store) => {
                                                        return (
                                                          <div className="checkbox avaiCheck">
                                                            <input
                                                              type="checkbox"
                                                              className="avail_checkbox"
                                                              value={true}
                                                              id={`store_id_${store?.id}`}
                                                              onClick={() =>
                                                                storeClickHandler(
                                                                  groups?.id,
                                                                  store
                                                                )
                                                              }
                                                              checked={
                                                                accounts.findIndex(
                                                                  (p) =>
                                                                    p.store_merchant_id ==
                                                                    store.merchant_id
                                                                ) > -1
                                                              }
                                                            />
                                                            <label
                                                              for={`store_id_${store?.id}`}
                                                            >
                                                              Store -{" "}
                                                              {store?.merchant
                                                                ?.account_name ??
                                                                ""}
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                              </div>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
              <li>
                <label for="OrphanAccount" class="required">
                  <strong>Orphan</strong> - No Cluster
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.payment_methods?.other_accounts
                    ) &&
                      master_setting_details?.payment_methods?.other_accounts.map(
                        (other_account) => {
                          return (
                            <Fragment key={other_account?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`other_account_id_${other_account?.id}`}
                                onClick={() =>
                                  otherAccountClickHandler(other_account)
                                }
                                checked={
                                  accounts.findIndex(
                                    (p) =>
                                      p.store_merchant_id == other_account.id
                                  ) > -1
                                }
                              />
                              <label
                                for={`other_account_id_${other_account?.id}`}
                              >
                                Store - {other_account?.account_name ?? ""}
                              </label>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`EDIT ACCOUNT PAYMENT METHOD`}
        open={editPmMasterSettingModal}
        closeModal={closeEditPmMasterSettingModal}
        submitModal={editPmMasterSettingSubmit(submitEditPmMasterSettingForm)}
        updateModal={editPmMasterSettingSubmit(
          submitEditPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_editPmMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="SalesTypeGeneralSettingSalesForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          {console.log("editPmMasterSettingErrors:", editPmMasterSettingErrors)}
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="SalesTypeTypeName" class="required">
                  Type Name
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][payment_method_id]"
                    class="required valid"
                    id="MasterSettingsPaymentMethodId"
                    {...editPmMasterSettingReg("payment_method_id")}
                    value={editPmMasterSettingInputForm?.payment_method_id}
                    disabled
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.payment_methods?.paymentMethods
                    ) &&
                      master_setting_details?.payment_methods?.paymentMethods.map(
                        (method) => {
                          return (
                            <option value={method?.id}>
                              {method.method_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={editPmMasterSettingErrors}
                    name="payment_method_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    <input
                      type="checkbox"
                      className="avail_checkbox"
                      value={0}
                      id={`edit_group_id_`}
                      checked={true}
                      disabled={true}
                    />
                    <label for={`edit_group_id_`}>
                      Group - {selectedPmSetting?.merchant?.account_name ?? ""}
                    </label>

                    <a
                      class="link"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`.account-multi-collapse-${
                        selectedPmSetting?.id ?? ""
                      }`}
                      aria-expanded="true"
                      aria-controls={`account-collapse-${
                        selectedPmSetting?.id ?? ""
                      }`}
                    >
                      {" "}
                      <i className="btn dropdown" />{" "}
                    </a>
                    <div
                      id={`account-collapse-${selectedPmSetting?.id ?? ""}`}
                      className={`group-collapse inner-checkbox account-multi-collapse-${
                        selectedPmSetting?.id ?? ""
                      }`}
                    >
                      <div class="groupSec">
                        <div className="checkbox avaiCheck flex-wrap">
                          <input
                            type="checkbox"
                            className="avail_checkbox"
                            value={true}
                            id={`cluster_id_${
                              selectedPmSetting?.cluster?.id ?? 0
                            }`}
                            checked={true}
                            disabled={true}
                          />
                          <label
                            for={`cluster_id_${
                              selectedPmSetting?.cluster?.id ?? 0
                            }`}
                          >
                            {selectedPmSetting?.cluster?.cluster_name
                              ? `Cluster - ${selectedPmSetting?.cluster?.cluster_name}`
                              : `Orphan - No Cluster`}
                          </label>
                          <a
                            class="link"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`.cluster-multi-collapse-${selectedPmSetting?.cluster?.id}`}
                            aria-expanded="true"
                            aria-controls={`cluster-collapse-${selectedPmSetting?.cluster?.id}`}
                          >
                            {" "}
                            <i className="btn dropdown" />{" "}
                          </a>
                          <div
                            class={`pt-3 inner-checkbox cluster-multi-collapse-${selectedPmSetting?.cluster?.id}`}
                            id={`cluster-collapse-${selectedPmSetting?.cluster?.id}`}
                          >
                            <div className="checkbox avaiCheck">
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={true}
                                id={`store_id_${selectedPmSetting?.store_merchant?.id}`}
                                checked={true}
                                disabled={true}
                              />
                              <label
                                for={`store_id_${selectedPmSetting?.store_merchant?.id}`}
                              >
                                Store -{" "}
                                {selectedPmSetting?.store_merchant
                                  ?.account_name ?? ""}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </div>
  );
};
export default PaymentMethod;
